import { axiosInstance } from "api/axios-config/axios-config";
import { Pagination } from "api/models/response/pagination";
import { DEFAULT_VOUCHER_SLICE_SIZE } from "commons/constants";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import { ICatalogue } from "mobx-stores/_models/base";
import {
  IAddOrder,
  IOrderProperties,
  IUpdateOrder,
} from "mobx-stores/_models/orders/order";
import { BaseBussiness } from "../base";

class OrderBusiness extends BaseBussiness<
  IOrderProperties,
  IAddOrder,
  IUpdateOrder,
  IOrderProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public getOrderStatuses = async () => {
    try {
      var res = await axiosInstance.get<Pagination<ICatalogue>>(
        "/api/app/purchase-order-item/purchase-order-status",
      );
      return res.data;
    } catch (error) {
      console.error("Fail getOrderStatus", error);
      return Promise.reject(error);
    }
  };

  public searchOrdersAsOptionItems = async (
    keyword: string,
    customerId?: string | null
  ) => {
    const customers = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_VOUCHER_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
      customerId: customerId,
    });
    return mapToDistinctOptionItems(
      customers.items,
      (x) => x.id,
      (x) => x.poNumber,
    );
  };

  public searchOrders = async (keyword: string) => {
    const res = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_VOUCHER_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
      customerId: "",
    });

    return res;
  };

  public exportExcel = async (
    fromPODate: string,
    toPODate: string,
    showSuccess: boolean,
  ) => {
    try {
      var res = await axiosInstance.get(this.url + "/export-excel", {
        params: {
          fromPODate,
          toPODate,
          showSuccess,
        },
        responseType: "blob",
      });
      // 🔍 Extract filename from Content-Disposition

      // const disposition = res.headers["Content-Disposition"];
      // let filename = "export.xlsx"; // fallback
      // const match = disposition?.match(
      //   /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      // );
      // if (match && match[1]) {
      //   filename = match[1].replace(/['"]/g, "");
      // }
      // return {
      //   blob: res.data as Blob,
      //   filename,
      // };
      return res.data as Blob;
    } catch (error) {
      console.error("Fail exportExcel", error);
      return Promise.reject(error);
    }
  };
}

export const orderBusiness = new OrderBusiness("/api/app/purchase-order");
